
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TableControl$1, Table } from "../../../../Widgets/Table/Table.js";
import { head, tail, isEmpty, singleton, ofArray, empty, take, toArray, length } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../../Widgets/Table/Types.js";
import { unwrap, toArray as toArray_1, defaultArg } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { RouterModule_nav, RouterModule_encodeParts } from "../../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapToolId } from "../../../../Shared/Helper.js";
import { FormState__getValidation, ConsumableId__get_unwrap } from "../../../../Shared/Shared.js";
import { TextButton, Button } from "../../../../Components/Button.js";
import { ModalSheet } from "../../../../Components/ModalSheet.js";
import { ConfirmationDialog, Dialog } from "../../../../Components/Dialog.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList, iterate } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Msg } from "./Types.js";
import { Input } from "../../../../Components/Input.js";
import { Checkbox } from "../../../../Components/Checkbox.js";
import { DatePicker } from "../../../../Components/DatePicker.js";
import { toString, utcNow } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { DetailViewHeader } from "../../../../Widgets/DetailViewHeader.js";
import { LabeledValue } from "../../../../Components/Text.js";
import { Feature, isFeatureEnabled } from "../../../../FeatureFlip.js";
import { TableContainer } from "../../../../Widgets/Container.js";
import { React_useElmish_Z6C327F2E } from "../../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../../Components/Skeleton.js";

function HistorySection(props) {
    let elems_1, TableRows, elems, TableRows_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = [createElement(Table, (TableRows = ((length(props.HistoryRows) > 3) ? toArray(take(3, props.HistoryRows)) : toArray(props.HistoryRows)), {
        ColumnDefinitions: [new ColumnDefinition$1("eventDate", "", t("general.date"), (row) => (new CellContent(7, [row.EventDate])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (row_1) => (new CellContent(0, [t(row_1.EventType)])), "none", "text"), new ColumnDefinition$1("toolName", "", t("general.tool"), (row_2) => (new CellContent(0, [row_2.InventoryName])), "none", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_3) => (new CellContent(0, [row_3.InventoryNumber])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_4) => (new CellContent(0, [row_4.Quantity])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (row_5) => (new CellContent(0, [row_5.Comment])), "none", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (row_6) => (new CellContent(4, [defaultArg(row_6.SignatureUrl, "")])), "none", "image"), new ColumnDefinition$1("commission", "", t("general.commission"), (dto) => (new CellContent(0, [dto.CommissionNumber])), "text", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (row_7) => (new CellContent(0, [row_7.Receiver])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (row_8) => (new CellContent(0, [row_8.Sender])), "none", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (row_9) => (new CellContent(0, [row_9.Storage])), "none", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "row",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["eventDate", "desc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: new OnTableRowClick$1(1, [(row_10) => {
                const matchValue = row_10.ToolHistoryElementType;
                return (matchValue.tag === 1) ? RouterModule_encodeParts(ofArray(["toolswithquantity", unwrapToolId(matchValue.fields[0])]), 1) : ((matchValue.tag === 2) ? "" : ((matchValue.tag === 3) ? RouterModule_encodeParts(ofArray(["consumables", ConsumableId__get_unwrap(matchValue.fields[0])]), 1) : RouterModule_encodeParts(ofArray(["tools", unwrapToolId(matchValue.fields[0])]), 1)));
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
        ComponentState: "enabled",
        Label: t("general.show_more_data"),
        OnClick: () => {
            setIsModalOpen(true);
        },
        TestId: "toolbox-history-show-more-data-button",
        Variant: "blueButton",
    }), createElement(ModalSheet, {
        CloseButtonTestId: "modal-sheet-history-close-button",
        Content: createElement(Table, (TableRows_1 = toArray(props.HistoryRows), {
            ColumnDefinitions: [new ColumnDefinition$1("eventDate", "", t("general.date"), (row_11) => (new CellContent(7, [row_11.EventDate])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (row_12) => (new CellContent(0, [t(row_12.EventType)])), "none", "text"), new ColumnDefinition$1("toolName", "", t("general.tool"), (row_13) => (new CellContent(0, [row_13.InventoryName])), "none", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_14) => (new CellContent(0, [row_14.InventoryNumber])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_15) => (new CellContent(0, [row_15.Quantity])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (row_16) => (new CellContent(0, [row_16.Comment])), "none", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (row_17) => (new CellContent(4, [defaultArg(row_17.SignatureUrl, "")])), "none", "image"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (row_18) => (new CellContent(0, [row_18.Receiver])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (row_19) => (new CellContent(0, [row_19.Sender])), "none", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (row_20) => (new CellContent(0, [row_20.Storage])), "none", "text")],
            Controls: empty(),
            Options: {
                BorderStyle: "full",
                CSVDownload: true,
                ConfigurableColumns: true,
                CustomTableFilters: false,
                DefaultSortColumn: ["eventDate", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(1, [(row_21) => {
                    const matchValue_1 = row_21.ToolHistoryElementType;
                    return (matchValue_1.tag === 1) ? RouterModule_encodeParts(ofArray(["toolswithquantity", unwrapToolId(matchValue_1.fields[0])]), 1) : ((matchValue_1.tag === 2) ? "" : ((matchValue_1.tag === 3) ? RouterModule_encodeParts(ofArray(["consumables", ConsumableId__get_unwrap(matchValue_1.fields[0])]), 1) : RouterModule_encodeParts(ofArray(["tools", unwrapToolId(matchValue_1.fields[0])]), 1)));
                }]),
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows_1,
        })),
        Controls: empty(),
        IsModalOpen: patternInput_1[0],
        OnClose: () => {
            setIsModalOpen(false);
        },
        Title: t("general.history"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ApiKeySection(props) {
    let Title, IsOpen, elems_1, elems, Title_1, elems_2, elems_3, Title_2, TableRows, Options;
    const t = useTranslation()[0];
    const createdKeyDialog = createElement(Dialog, (Title = t("api_receiver.api_keys.created_dialog_title"), (IsOpen = (props.CreatedKey != null), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [reactElement("p", {
            className: join(" ", ["text-sm"]),
            children: t("api_receiver.api_keys.created_dialog_description"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], (elems = [reactElement("input", {
            readOnly: true,
            value: defaultArg(props.CreatedKey, ""),
            className: join(" ", ["flex-1", "text-sm", "border", "border-border", "rounded-lg", "px-3", "py-2", "bg-background", "text-text-muted", "font-mono"]),
        }), createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.copy"),
            OnClick: () => {
                iterate((text) => {
                    navigator.clipboard.writeText(text);
                }, toArray_1(props.CreatedKey));
            },
            TestId: "api-key-created-copy-button",
            Variant: "secondary",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
        Controls: singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.close"),
            OnClick: () => {
                props.Dispatch(new Msg(10, []));
            },
            TestId: "api-key-created-close-button",
            Variant: "blueButton",
        })),
        IsOpen: IsOpen,
        OnClose: () => {
            props.Dispatch(new Msg(10, []));
        },
        Title: Title,
    })));
    const createDialog = createElement(Dialog, (Title_1 = t("api_receiver.api_keys.create_dialog_title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = [createElement(Input, {
            ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.name"),
            OnChange: (value_14) => {
                props.Dispatch(new Msg(5, [value_14]));
            },
            TestId: "api-key-name-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Name,
        }), Checkbox({
            ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
            IsChecked: props.WritePermission,
            Label: t("api_receiver.api_keys.write_permission"),
            OnCheck: (value_15) => {
                props.Dispatch(new Msg(6, [value_15]));
            },
            TestId: "api-key-write-permission-checkbox",
        }), createElement(DatePicker, {
            ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
            IsClearable: true,
            Label: t("api_receiver.api_keys.expiration_date"),
            MinDate: utcNow(),
            OnChange: (value_16) => {
                props.Dispatch(new Msg(7, [value_16]));
            },
            TestId: "api-key-expiration-date",
            Value: unwrap(props.ExpirationDate),
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.cancel"),
            OnClick: () => {
                props.Dispatch(new Msg(4, []));
            },
            TestId: "api-key-create-cancel-button",
            Variant: "default",
        }), createElement(TextButton, {
            ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.save"),
            OnClick: () => {
                props.Dispatch(new Msg(8, []));
            },
            TestId: "api-key-create-save-button",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(4, []));
        },
        Title: Title_1,
    }));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_3 = [createDialog, createdKeyDialog, createElement(ConfirmationDialog, (Title_2 = t("api_receiver.api_keys.deactivate_confirm_title"), {
        Description: t("api_receiver.api_keys.deactivate_confirm_description"),
        FormState: props.FormState,
        IsOpen: props.KeyPendingDeletion != null,
        OnClose: () => {
            props.Dispatch(new Msg(12, []));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(13, []));
        },
        Title: Title_2,
    })), createElement(Table, (TableRows = toArray(props.ApiKeys), (Options = {
        BorderStyle: "row",
        CSVDownload: true,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["expiration_date", "desc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "singleRow",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Name])), "none", "text"), new ColumnDefinition$1("prefix", "", t("api_receiver.api_keys.prefix"), (row_1) => (new CellContent(0, [row_1.ApiKeyPrefix])), "none", "text"), new ColumnDefinition$1("write_permission", "", t("api_receiver.api_keys.write_permission"), (row_2) => (new CellContent(0, [row_2.WritePermission ? t("general.yes") : t("general.no")])), "none", "text"), new ColumnDefinition$1("expiration_date", "", t("api_receiver.api_keys.expiration_date"), (row_3) => {
            let matchValue;
            return new CellContent(0, [(matchValue = row_3.ExpirationDate, (matchValue == null) ? t("api_receiver.api_keys.no_expiration") : toString(matchValue, "dd.MM.yyyy"))]);
        }, "none", "text"), new ColumnDefinition$1("status", "", t("api_receiver.api_keys.status"), (row_4) => (new CellContent(0, [row_4.Deleted ? t("api_receiver.api_keys.deleted") : t("api_receiver.api_keys.active")])), "none", "text")],
        Controls: ofArray([new TableControl$1(t("api_receiver.api_keys.create"), undefined, (_arg_8) => {
            props.Dispatch(new Msg(3, []));
        }, false, false, "api-receiver-create-api-key-button"), new TableControl$1(t("api_receiver.api_keys.deactivate"), undefined, (rows) => {
            let matchResult, apiKey_1;
            if (!isEmpty(rows)) {
                if (isEmpty(tail(rows))) {
                    if (!head(rows).Deleted) {
                        matchResult = 0;
                        apiKey_1 = head(rows);
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    props.Dispatch(new Msg(11, [apiKey_1]));
                    break;
                }
                case 1: {
                    break;
                }
            }
        }, true, false, "api-receiver-deactivate-api-key-button")]),
        Options: Options,
        TableKey: "api-keys-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function ApiReceiverDetails(props) {
    let elems_4, Title, matchValue, elems_1, elems, elems_2, elems_3;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_4 = [createElement(DetailViewHeader, (Title = t("settings.user_management.api.details.title"), {
        Badges: empty(),
        OnBack: () => {
            RouterModule_nav(ofArray(["settings", "user-management", "api"]), 1, 1);
        },
        OnEdit: unwrap((matchValue = props.UserData.Role, (matchValue === "system") ? undefined : ((matchValue === "toolManager") ? undefined : ((matchValue === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["settings", "user-management", "api", props.ApiReceiver.Id, "edit"]), 1, 1);
        }))))),
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "mx-4", "mt-3"])], (elems = toList(delay(() => append(singleton_1(LabeledValue({
        Label: t("general.name"),
        Value: props.ApiReceiver.Name,
    })), delay(() => (isFeatureEnabled(new Feature(17, [])) ? singleton_1(LabeledValue({
        Label: t("business_units.business_unit"),
        Value: defaultArg(props.ApiReceiver.BusinessUnitName, ""),
    })) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["pt-5"])], (elems_2 = [createElement(TableContainer, {
        Content: createElement(ApiKeySection, {
            ApiKeys: props.ApiKeys,
            CreatedKey: unwrap(props.CreatedKey),
            Dispatch: props.Dispatch,
            ExpirationDate: unwrap(props.ExpirationDate),
            FormState: props.FormState,
            IsDialogOpen: props.IsDialogOpen,
            KeyPendingDeletion: unwrap(props.KeyPendingDeletion),
            Name: props.Name,
            WritePermission: props.WritePermission,
        }),
        Title: "api_receiver.api_keys.title",
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["pt-5"])], (elems_3 = [createElement(TableContainer, {
        Content: createElement(HistorySection, {
            HistoryRows: props.HistoryRows,
        }),
        Title: "general.history",
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function DetailsView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.ApiReceiverId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.ApiReceiver;
    const matchValue_1 = state_1.HistoryRows;
    const matchValue_2 = state_1.ApiKeys;
    let matchResult, apiKeys, apiReceiver, historyRows;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        apiKeys = matchValue_2.fields[0];
        apiReceiver = matchValue.fields[0];
        historyRows = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ApiReceiverDetails, {
                ApiKeys: apiKeys,
                ApiReceiver: apiReceiver,
                CreatedKey: unwrap(state_1.CreatedKey),
                Dispatch: patternInput[1],
                ExpirationDate: unwrap(state_1.ExpirationDate),
                FormState: state_1.FormState,
                HistoryRows: historyRows,
                IsDialogOpen: state_1.IsDialogOpen,
                KeyPendingDeletion: unwrap(state_1.KeyPendingDeletion),
                Name: state_1.Name,
                UserData: props.UserData,
                WritePermission: state_1.WritePermission,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

